import React, { useEffect, useRef, useState } from "react";
import styles from './Header.module.scss';
import Logo from "../logo/Logo";
import { useAuth } from "../../contexts/AuthContext";
import BellIcon from './Bell.svg';
import Menu from "../menu/Menu";
import useClickOutside from "../../hooks/useClickOutside";
import PropTypes from "prop-types";
import ProfilePicture from "../profilePicture/ProfilePicture";
import {ReactComponent as XIcon} from './X.svg';
import {ReactComponent as MenuIcon} from './Menu.svg';
import useDeviceType from "../../hooks/useDeviceType";
import NotificationPanel from "../notificationPanel/NotificationPanel";
import axiosClient from "../../api/axiosClient";

const Header = ({
  showMenu = false,
  onToggleMenu
}) => {
  const [isDropdownActive, setIsDropdownActive] = useState(false);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const { isAuthenticated, authenticatedUser } = useAuth();
  const menuRef = useRef(null);
  const { isDesktopAndAbove } = useDeviceType();

  useClickOutside(menuRef, () => setIsDropdownActive(false));

  useEffect(() => {
    if (!isAuthenticated) return;
    axiosClient.get('notifications')
      .then((response) => {
        if (response.data?.notifications) {
          setNotifications(response.data.notifications);
        }
      })
      .catch(() => {});
  }, [isAuthenticated]);

  const handleMarkAllRead = () => {
    axiosClient.post('notifications/mark-all-read')
      .then(() => {
        setNotifications((prev) => prev.map((n) => ({ ...n, isRead: true })));
      })
      .catch(() => {});
  };

  const unreadCount = notifications.filter((n) => !n.isRead).length;

  return (
    <div className={styles.container}>
      <Logo
        variant="header"
      />
      { isAuthenticated && <div className={styles.userSection}>
        <div
          className={styles.notification}
          onClick={() => setIsNotificationOpen(true)}
        >
          <img src={BellIcon} alt="Notification" />
          {unreadCount > 0 && <span>{unreadCount}</span>}
        </div>
        <div
          onClick={() => setIsDropdownActive(!isDropdownActive)}
          ref={menuRef}
        >
          <ProfilePicture {...authenticatedUser} />
          { isDropdownActive && <div 
            className={styles.menu}
            onClick={() => setIsDropdownActive(false)}
          >
            <Menu 
              type="profile"
              isDropdown={true}
            />
          </div> }
        </div>
        {!isDesktopAndAbove && <span onClick={() => onToggleMenu(!showMenu)}>
          {showMenu ? <XIcon /> : <MenuIcon />}
        </span>}
      </div> }
      {isNotificationOpen && (
        <NotificationPanel
          onClose={() => setIsNotificationOpen(false)}
          initialNotifications={notifications}
          onNotificationsChange={setNotifications}
          onMarkAllRead={handleMarkAllRead}
        />
      )}
    </div>
  )
};

Header.propTypes = {
  showMenu: PropTypes.bool,
  onToggleMenu: PropTypes.func
}

export default Header;